<template>
  <div
    v-if="!loading"
    style="
      background-color: white; 
      padding-top: 30px;
      padding-left: 50px;
      padding-right: 100px
      padding-bottom: 50px;
    "
  >
      <Experiences 
        class="mb-4 mt-4" 
        :candidate_id="candidate_id"
        :recruiter_id="recruiter_id"
      />
      <hr class="mt-4 mb-4" />
      <Educations 
        class="mb-4 mt-4" 
        :candidate_id="candidate_id"
        :recruiter_id="recruiter_id"
      />
      <hr class="mt-4 mb-4" />
      <ExtraCourses
        class="mb-4 mt-4" 
        :candidate_id="candidate_id"
      />
      <hr class="mt-4 mb-4" />
      <Certifications 
        class="mb-4 mt-4" 
        :candidate_id="candidate_id"
        :recruiter_id="recruiter_id"
      />
      <hr class="mt-4 mb-4" />
      <CandidateSkills
        class="mt-4 mb-4" 
        :candidate_id="candidate_id"
      />
      <hr class="mt-4 mb-4" />
      <Language
        class="mt-4 mb-4 pb-5" 
        :candidate_id="candidate_id" 
      />
  </div>
</template>

<script>
import Experiences from "@/Recruiters/TalentBank/Experiences/Index.vue";
import Educations from "@/Recruiters/TalentBank/Educations/Index.vue";
import ExtraCourses from "@/Recruiters/TalentBank/ExtraCourses/Index.vue";
import Certifications from "@/Recruiters/TalentBank/Certifications/Index.vue";
import CandidateSkills from "components/CandidateSkills.vue";
import Language from "@/Recruiters/TalentBank/Languages/Index.vue";

export default {
  components: {
    Experiences,
    Educations,
    ExtraCourses,
    Certifications,
    CandidateSkills,
    Language
  },

  data() {
    return {
      loading: false,
    }
  },

  props: [
    "candidate_id",
    "recruiter_id"
  ],

  watch: {
    candidate_id() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 300);
    }
  }
}
</script>